import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=ca1868a2&scoped=true"
import script from "./list2.vue?vue&type=script&lang=js"
export * from "./list2.vue?vue&type=script&lang=js"
import style0 from "./list2.vue?vue&type=style&index=0&id=ca1868a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1868a2",
  null
  
)

export default component.exports